var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-forms"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg6":""}},[_c('v-card',[_c('v-card-text',{},[_c('password-form')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }